import Button from '@ui/button/Button';
import ModalDialog from '@stone/components/modal/ModalDialog';
import api from '@utils/api';
import useQueryStringBoolean from '@utils/useQueryStringBoolean';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SuggestedCountryModal from './SuggestedCountryModal';
import ConfirmCountryModal from './ConfirmCountryModal';
import Icon from '@stone/ui/icon/Icon';
import '@stone/scss/components/country-selector/_countryselector.scss';
import CountrySelectorList from './CountrySelectorList';
import { useLangChecker } from '@common/utils/i18n';
const CountryModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = (props.fromCheckout && useState(false)) || useQueryStringBoolean('countryselector');
    const [data, setData] = useState();
    const [confirmed, setConfirmed] = useState();
    const [requireconfirm, setRequireconfirm] = useState();
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const fromClass = useMemo(() => (props.fromHeader ? 'header' : 'footer'), [props.fromHeader]);
    useEffect(() => {
        if (!props.fromCheckout) {
            if (open) {
                api.getMiniCart().then((cart) => {
                    setRequireconfirm(cart.isExchange || false);
                    api.countrySelectorJson().then((data) => {
                        setData(data);
                    });
                });
            }
        }
        else {
            api.countrySelectorJson().then((data) => {
                setData(data);
            });
        }
    }, [open]);
    const confirmationDialog = () => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row row--inner countryselector-modal" },
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "countryselector-modal__description" }, t('exchange.changecountrywarning')),
                React.createElement("div", { className: "countryselector-modal__description" }, t('checkout.shipping.changecountryproceed')))),
        React.createElement("div", { className: "row--inner" },
            React.createElement("div", { className: "col-6 col-lg-3" },
                React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: () => {
                        setOpen(false);
                    } }, t('label.no'))),
            React.createElement("div", { className: "col-6 col-lg-3" },
                React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: () => {
                        setConfirmed(true);
                    } }, t('label.yes'))))));
    const modal = () => (React.createElement(ModalDialog, { isOpen: open, onRequestClose: () => {
            setOpen(false);
            // analytics.countryselectorClose();
        }, hasDivisor: !requireconfirm || confirmed, contentLabel: t('modal.country.title'), subtitle: requireconfirm && !confirmed ? '' : t('modal.country.description'), className: "country-modal", fullWidth: true, fullHeight: true }, requireconfirm && !confirmed ? (React.createElement(React.Fragment, null, confirmationDialog())) : (React.createElement(React.Fragment, null,
        React.createElement(CountrySelectorList, { regions: data, isModal: true })))));
    if (props.children && !props.fromCheckout) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "countryselector" },
                React.createElement("button", { type: "button", onClick: () => {
                        setOpen(true);
                    }, dangerouslySetInnerHTML: { __html: props.children } })),
            data && modal()));
    }
    if (props.fromBookAnAppointment) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "countryselector" },
                t('bookanappointment.location.message', { country: window.countryname }),
                ' ',
                React.createElement("button", { className: "link-button", type: "button", onClick: () => {
                        setOpen(true);
                    } }, t('bookanappointment.differentlocation'))),
            data && modal()));
    }
    if (props.fromCheckout) {
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: "link-button", type: "button", "aria-haspopup": 'dialog', onClick: () => {
                    setOpenConfirmation(true);
                } }, props.children),
            data && modal(),
            React.createElement(ConfirmCountryModal, { open: openConfirmation, onFeeback: (confirm) => {
                    setOpenConfirmation(false);
                    if (confirm) {
                        setOpen(true);
                    }
                } })));
    }
    if (window.ssr && fromClass === 'footer') {
        return (React.createElement("a", { href: window.basePath + 'country-selector', className: "footer-countrybutton" },
            React.createElement("span", { className: `${fromClass}-countrybutton__content` },
                React.createElement("span", { className: `${fromClass}-countrybutton__title`, ref: useLangChecker }, t('label.shoppingcountry')),
                ' ',
                window.countryname),
            React.createElement(Icon, { name: "open", family: "10", inverted: true })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: `${fromClass}-countrybutton`, onClick: (e) => {
                e.preventDefault();
                setOpen(true);
            }, "aria-haspopup": "dialog" },
            React.createElement("span", { className: `${fromClass}-countrybutton__content` },
                React.createElement("span", { className: `${fromClass}-countrybutton__title`, ref: useLangChecker }, t('label.shoppingcountry')),
                ' ',
                window.countryname),
            React.createElement(Icon, { name: "open", family: "10", inverted: !props.fromHeader })),
        data && modal(),
        !props.editMode && React.createElement(SuggestedCountryModal, { setCountrySelectorOpen: setOpen })));
};
export default CountryModal;
